import { useNavigate } from "react-router-dom";
import { ArrowLeft, SearchX } from "lucide-react";

// Estado vacío para páginas de detalle en 404/409/403.
export const NoEncontrado = ({ texto = "Registro no encontrado o fuera de tu alcance", detalle }) => {
  const nav = useNavigate();
  return (
    <main className="mx-auto max-w-xl px-6 py-16 text-center" data-testid="no-encontrado">
      <SearchX size={36} className="mx-auto text-[#E8643C]" />
      <h1 className="mt-3 font-serif-display text-2xl font-bold text-[#0B2545]">{texto}</h1>
      {detalle && <p className="mt-2 text-sm text-[#5C5850]">{detalle}</p>}
      <button onClick={() => nav(-1)} data-testid="no-encontrado-volver" className="mt-6 inline-flex items-center gap-1 rounded-full bg-[#0B2545] px-4 py-2 text-xs font-semibold text-white hover:bg-[#E8643C]"><ArrowLeft size={14} />Volver</button>
    </main>
  );
};
